import React, { useEffect, useState } from 'react';
import { TextField } from '@mui/material';
import clsx from 'clsx';

import './DiscountCodeDialog.scss';
import { BasicDialog } from '../../common/BasicDialog';

interface DiscountCodeDialogProps {
  open: boolean;
  isValidating: boolean;
  error?: string;
  onClose: () => void;
  onValidate: (code: string) => Promise<void>;
}

const DiscountCodeDialog: React.FC<DiscountCodeDialogProps> = ({
  open,
  error,
  isValidating,
  onClose,
  onValidate,
}) => {
  const [discountCode, setDiscountCode] = useState('');
  const [validationError, setValidationError] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {
    if (error) {
      setValidationError('Invalid Discount Code');
      setIsSuccess(false);
    } else {
      setValidationError('');
    }
  }, [error]);

  const handleSubmit = async () => {
    if (!discountCode) {
      setIsSuccess(false);
      return;
    }

    try {
      await onValidate(discountCode);
      setIsSuccess(true);
      // Close the dialog after 2 seconds
      setTimeout(() => {
        onClose();
      }, 1000);
    } catch (e) {}
  };

  const handleClose = () => {
    setDiscountCode('');
    setIsSuccess(false);
    onClose();
  };

  return (
    <BasicDialog
      visible={open}
      title="Claim your benefit"
      ctaString="Apply"
      isLoading={isValidating}
      disabled={!discountCode}
      onYes={handleSubmit}
      onClose={handleClose}
      width="sm"
      className="discount-code-dialog"
    >
      <div className="discount-code-dialog__content">
        <p className="discount-code-dialog__info">
          If you have a <strong>referral code</strong> from a friend, apply it here for{' '}
          <strong>30% off</strong>. If you have a <strong>discount code</strong>, type it here too.
        </p>
        <TextField
          autoFocus
          margin="dense"
          label="Enter referral or promo code"
          type="text"
          fullWidth
          variant="standard"
          value={discountCode}
          onChange={(e) => {
            setDiscountCode(e.target.value);
            setValidationError('');
          }}
          className="discount-code-dialog__input"
        />
        <div
          className={clsx(
            'discount-code-dialog__error',
            isSuccess && 'discount-code-dialog__success'
          )}
        >
          {isSuccess ? 'Code applied!' : validationError}
        </div>
      </div>
    </BasicDialog>
  );
};

export default DiscountCodeDialog;
